// import { appletCarefreeServeOrdersListApi } from '../api/service';
// import store from '../store';
// import { SERVICE_HAPPY_ORDER_UPDATE } from '../store/mutationTypes';

import { userInfoCommitComposable } from '@/composables';

// import { userGetinfoApi } from '@/api/common';

export default [
  (to, from, next) => {
    console.log(to);
    if (from.name === 'usedCar.create') {
      localStorage.setItem('usedCarDetail', 1);
    } else {
      localStorage.removeItem('usedCarDetail');
    }

    const { token } = to.query;

    console.log('打印');
    console.log(token);

    try {
      if (token) {
        // 去除授权参数
        const toQuery = { ...to.query };
        delete toQuery.token;
        localStorage.setItem('token', JSON.stringify(decodeURIComponent(token || '')));
        // token已删除是否删除license？？
        next({ name: to.name, params: to.params, path: to.path, query: toQuery, replace: true });
      } else {
        // localStorage.setItem('token', JSON.stringify('TK-1612235842-rzEl9n1tUMQssNAMTfuLYrQ8oHuz23Yd'));
        next();
      }
    } catch (error) {
      console.error(error);
      // alert(error);
    }
  },
  async (to, from, next) => {
    userInfoCommitComposable;
    next();
  },
  // 无优服务权限
  // async (to, from, next) => {
  //   if (!['service.happy.detail', 'service.happy.rights'].some((name) => to.name === name)) {
  //     return next();
  //   }
  //   // 获取权益包
  //   const resData = await appletCarefreeServeOrdersListApi({}, { to });
  //   store.commit(SERVICE_HAPPY_ORDER_UPDATE, resData.data);
  //   // 没有权益包，进入介绍页
  //   if (!resData.data || !resData.data.length) {
  //     if (!['service.happy.detail'].some((name) => to.name === name)) {
  //       return next({ name: 'service.happy.detail' });
  //     }
  //     return next();
  //   }
  //   // 有权益包，进入列表页
  //   if (!['service.happy.rights'].some((name) => to.name === name)) {
  //     return next({ name: 'service.happy.rights' });
  //   }
  //   return next();
  // },
];
